export default {
  title: "Spot's Stats",
  label: {
    by: 'by',
    and: 'and',
    x: {
      empty: ' ',
      setter: 'setter',
      color: 'color',
      sector: 'sector',
      lane: 'lane',
      like: 'like',
      grade: 'grade',
      date: 'settling date',
    },
    y: {
      count: 'number of routes',
      comments: 'nombre of comments',
      like: 'average like',
      grade: 'average grade',
    },
    like: {
      no: 'no vote',
      '0': '♥',
      '1': '♥ ♥',
      '2': '♥ ♥ ♥',
    },
    no_setter: 'no setter',
    no_lane: 'no lane',
    no_color: 'no color',
  },
  helper: {
    no_route: {
      title: 'Sorry, no route found!',
      body: 'We couldn’t display stats because their is not route in the Spot. Please create a Route first.',
    },
  },
}
